<script setup lang="ts">
import LayersPanel from '@/components/panels/LayersPanel.vue'
import PropertiesPanel from '@/components/panels/PropertiesPanel.vue'
import HistoryPanel from '@/components/panels/HistoryPanel.vue'
import HistogramPanel from '@/components/panels/HistogramPanel.vue'
import ChannelsPanel from '@/components/panels/ChannelsPanel.vue'
import ActionsPanel from '@/components/panels/ActionsPanel.vue'
import TabbedPane from '@/components/panels/TabbedPane.vue'
import NavigatorPanel from '@/components/panels/NavigatorPanel.vue'
import SwatchesPanel from '@/components/panels/SwatchesPanel.vue'
import LayerCompsPanel from '@/components/panels/LayerCompsPanel.vue'
</script>

<template>
  <div class="dock">
    <div class="pane props"><PropertiesPanel /></div>
    <div class="pane histogram"><HistogramPanel /></div>
    <div class="pane history"><HistoryPanel /></div>
    <div class="pane channels">
      <TabbedPane :tabs="[{ id: 'navigator', label: 'panel.navigator' }, { id: 'swatches', label: 'panel.swatches' }, { id: 'channels', label: 'panel.channels' }, { id: 'comps', label: 'panel.comps' }, { id: 'actions', label: 'panel.actions' }]" storage-key="bpe.dock.tab">
        <template #navigator><NavigatorPanel /></template>
        <template #swatches><SwatchesPanel /></template>
        <template #channels><ChannelsPanel /></template>
        <template #comps><LayerCompsPanel /></template>
        <template #actions><ActionsPanel /></template>
      </TabbedPane>
    </div>
    <div class="pane layers"><LayersPanel /></div>
  </div>
</template>

<style scoped>
.dock {
  display: grid;
  grid-template-rows: minmax(60px, 30%) auto minmax(60px, 100px) minmax(90px, 200px) 1fr;
  min-height: 0;
  min-width: 0;
  overflow: hidden;
  background: var(--bg-1);
}
.pane {
  min-height: 0;
  min-width: 0;
  overflow: auto;
  display: flex;
  flex-direction: column;
  border-bottom: 1px solid var(--line-region);
}
.pane:last-child {
  border-bottom: none;
}
</style>
